// Home.vue

<template>
 
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app dark :color="barColor">
      
      <v-toolbar-title style="width: 450px" class="ml-0 pl-4">
        <span class="hidden-xs-and-down">
          CGR Webapp <span class="font-weight-thin text-sm-body-1">v{{version}}</span>
          
        </span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

     <v-bottom-sheet v-model="sheet" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon
          color="white"
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
        
      </template>
      <v-sheet class="text-center" height="200px">
        <v-btn
          class="mt-6"
          text
          color="error"
          @click="sheet = !sheet"
        >Fermer</v-btn>
        <div class="my-3">UUID {{this.$root.uuid}}</div>
      </v-sheet>
    </v-bottom-sheet>
    </v-app-bar>

</template>
<script>

import {AppService} from '../../providers/AppService.js';
const appService = new AppService();
export default {  
  name: "Bandeau",

  data: () => ({
    drawer: null,
    barColor: "secondary",
    sheet: false,
    version: null
  }),
  mounted: function () {
    this.version = appService.APP_VERSION;
  }


};
</script>